export default "/img/v11-0-0_fig1.2e3f973a25ebf5e2d5d7a7cfa0672dcd.png";